export default __webpack_public_path__ + "static/media/hoops-salesDocs-has-arrived.9465cc5b.png";